import { LegalPage } from "./Legal";

export default function Terms() {
  return <LegalPage base="terms" path="/conditions" testid="terms-page" />;
}
